import { token } from '@atlaskit/tokens';
import {
	ButtonStyle,
	CommonLayout,
	CornerStyle,
	Height,
	SPOTLIGHT_EXTENSION_TYPE,
} from '@atlassian/company-hub-common';

import { SPOTLIGHT_EXTENSION_KEY } from '../constants';
import type { SpotlightParameters } from '../types';

export const mockInitialSpotlightParameters: SpotlightParameters = {
	extensionTitle: 'test',
	height: Height.MEDIUM,
	backgroundColor: token('color.background.accent.orange.subtlest'),
	cornerStyle: CornerStyle.ROUNDED,
	layout: CommonLayout.SPLIT_IMAGE_RIGHT,
	content: {
		text: {
			title: 'Give your spotlight a title',
			description:
				'Design a spotlight to highlight your most vital information. Bring the most important messages to life with custom colors, a powerful image, and flexible layouts.',
			textColor: token('color.text'),
		},
		button: {
			isButtonShown: false,
			text: '',
			link: '',
			style: ButtonStyle.DEFAULT,
		},
		image: {
			imageSrc:
				'https://images.unsplash.com/photo-1527519135413-1e146b552e10?q=80&w=2940&auto=format',
			altText: 'Landscape photo of sand dunes desert',
		},
	},
};

export const mockRawNodeSpotlightExtensionWithExistingParameters: {
	attrs: {
		extensionKey: string;
		extensionType: string;
		layout: string;
		localId: string;
		parameters: SpotlightParameters;
		text: null;
	};
	type: string;
} = {
	type: 'extension',
	attrs: {
		extensionType: SPOTLIGHT_EXTENSION_TYPE,
		extensionKey: SPOTLIGHT_EXTENSION_KEY,
		parameters: mockInitialSpotlightParameters,
		text: null,
		layout: 'default',
		localId: 'some-localId-1',
	},
};
